import moment from "moment-jalaali";
import React from "react";

class CustomTable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      columns: props.columns,
      dataPrint: props.dataPrint,
      printTitle: props.printTitle,
      selectedColumns: props.selectedColumns,
      dataSource: props.dataSource,
      properties: props.properties,
    };
  }
  componentDidMount() {
    const {
      columns,
      dataPrint,
      printTitle,
      selectedColumns,
      dataSource,
      properties,
    } = this.state;
    this.setState({
      columns: columns,
      dataPrint: dataPrint,
      printTitle: printTitle,
      selectedColumns: selectedColumns,
      dataSource: dataSource,
      properties: properties,
    });
  }
  //   /**
  //    *
  //    * @param {object} np
  //    */
  //   componentWillReceiveProps(np) {
  //     this.setState({
  //       columns: np.columns,
  //       dataPrint: np.dataPrint,
  //       printTitle: np.printTitle,
  //     });
  //   }

  openNewWindow(columns, printTitle, properties) {
    const newWindow = window.open("", "_blank");
    const tableContent = this.generateTableContent();

    newWindow.document.write(`
      <html>
        <head>
          <title>پرینت ${printTitle}</title>
          <style type="text/css">

        @font-face {
            font-family: "samim";
            src: url("/src/fonts/Samim-FD.ttf");
        }
       
        @page {
          size: A4;
          margin: 0;
        }
  
        @media print{
            body {
                -webkit-print-color-adjust: exact;
                font-family: samim, serif;
            }
            html, body{
                overflow: inherit;
            }
            .cl{
                -webkit-print-color-adjust: exact;
                background: #000;
            }
        }

        body {
            text-align: right;
            font-family: samim, serif;
            direction: rtl;
            font-size: 10px;
        }

        .float-right {
            float: right;
        }

        .text-left {
            float: left;
            text-align: left;
        }
        .reservePrints{
            padding: 5px;
        }
        .print-head{
            background: #f2f2f2;
        }

        .print-head > div {
            width: 33.333%;
        }

        .center {
            text-align: center;
        }

        .bold {
            font-weight: bold;
        }

        .clear {
            clear: both;
        }

        .sp-large {
            font-size: 1.5em;
            padding: 3px 15px;
        }
        .print-page:after{
            clear: both;
            display: inline-block;
        }
        .print-page h3 {
            margin: 0px auto;
            text-align: center;
            padding: 0px;
        }
        [class^="ant-col-"],
        [class*=" ant-col-"],
        .ant-steps-vertical .ant-steps-head {
            float: right;
            flex: 0 0 auto;
        }
        .row {
            position: relative;
            margin-left: 0px;
            margin-right: 0px;
            height: auto;
            zoom: 1;
            display: block;
        }
        .row:after {
            content:'';
            clear: both;
            display:block;
            visibility: hidden;
            font-size: 0;
            height: 0;
        }
        .listTooltip > span {
            float: right;
            margin-left: 6px;
            margin-right: 0px;
        }
        .listTooltip > i {
            float: left;
            margin-right: 0px;
            margin-left: 0px;
        }
        {{pageStyle}}
    </style>
        </head>
        <body style="font-family: "samim" !important">
        <div style="display:flex;align-items:center;justify-content:space-around;width:100%">
         <div>تاریخ گزارش گیری: ${moment(properties?.date).format(
           "jDD-jMM-jYYYY"
         )}</div>
          <h1 style="text-align:center">پرینت ${printTitle}</h1>
          <div style="visibility:${
            this.props.properties?.range ? "visible" : "hidden"
          }">
          <div>از تاریخ: ${moment(this.props.properties?.range?.start).format(
            "jDD-jMM-jYYYY"
          )}</div>
          <div>تا تاریخ: ${moment(this.props.properties?.range?.stop).format(
            "jDD-jMM-jYYYY"
          )}</div>
          </div>
        </div>
          ${tableContent}
        </body>
      </html>
    `);

    newWindow.document.close();
  }

  generateTableContent() {
    const tableHeader = this.props.columns

      .map(
        (column, index) =>
          `<th style= "color:black;text-align:center; background-color: #ddd; padding:4px; border: 1px solid black;font-family: samim; font-weight: bold;font-size:12px">${column.title}</th>`
      )
      .join("");

    const tabelRows = this.props.dataSource
      .map((row, rowIndex) => {
        const rowCells = this.props.columns

          .map((column, colIndex) =>
            column.key === "date"
              ? `<td style="padding: 8px; border: 1px solid black;font-size:12px;font-family: samim">${moment(
                  row[column.key]
                ).format("jYYYY-jMM-jDD")}</td>`
              : column.key === "time" && this.state.printTitle.includes("تردد")
              ? `<td style="padding: 8px; border: 1px solid black;font-size:12px;font-family: samim">${moment(
                  row.datetime
                ).format("HH:mm")}</td>`
              : column.key === "time"
              ? `<td style="padding: 8px; border: 1px solid black;font-size:12px;font-family: samim">${moment(
                  row[column.key]
                ).format("HH:MM")}</td>`
              : column.key === "datetime"
              ? `<td style="padding: 8px; border: 1px solid black;font-size:12px;font-family: samim">${moment(
                  row[column.key]
                ).format("jYYYY-jMM-jDD")}</td>`
              : column.key === "day" && this.state.printTitle.includes("تردد")
              ? `<td style="padding: 8px; border: 1px solid black;font-size:12px;font-family: samim">${moment(
                  row.datetime
                ).format("dddd")}</td>`
              : column.key === "day"
              ? `<td style="padding: 8px; border: 1px solid black;font-size:12px;font-family: samim">${
                  row[column.key]
                }</td>`
              : column.key.includes("status")
              ? `<td style="padding: 8px; border: 1px solid black;font-size:12px;font-family: samim; ">${
                  row[column.key] === "accepted"
                    ? "تایید تردد"
                    : row[column.key] === "waiting"
                    ? "درانتظار تایید"
                    : "رد تردد"
                }</td>`
              : !!row[column.key]
              ? `<td style="padding: 8px; border: 1px solid black;font-size:12px;font-family: samim">${
                  row[column.key]
                }</td>`
              : `<td style="padding: 8px; border: 1px solid black;font-size:12px;font-family: samim">    
                   ـ 
                 </td>`
          )
          .join("");
        return `<tr>${rowCells}</tr>`;
      })
      .join("");

    // const tableRows = this.props.data
    //   .map((row, rowIndex) => {
    //     const rowCells = this.props.columns
    //       .map(
    //         (column, colIndex) =>
    //           `<td style="padding: 8px; border: 1px solid #ccc;">${row[column]}</td>`
    //       )
    //       .join("");
    //     return `<tr>${rowCells}</tr>`;
    //   })
    //   .join("");

    return `
      <table style="border-collapse: collapse; width: 100%; font-family: Arial, sans-serif;">
        <thead>
          <tr style="background-color: #f2f2f2; font-weight: bold;">
            ${tableHeader}
          </tr>
        </thead>
        <tbody style="text-align:center">
            ${tabelRows}
        </tbody>
      </table>
    `;
  }

  render() {
    const {
      columns,
      dataPrint,
      printTitle,
      selectedColumns,
      dataSource,
      properties,
    } = this.state;

    return (
      <div>
        <h1>{printTitle}</h1>
        <button
          onClick={() => this.openNewWindow(columns, printTitle, properties)}
        >
          Print in new window
        </button>
      </div>
    );
  }
}

export default CustomTable;
